export default __webpack_public_path__ + "static/media/vip6.79e11513.webp";